"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var moment = require("moment");
var constants_1 = require("../../../constants");
var server_1 = require("../../../helpers/server");
var ProposalMap_1 = require("./ProposalMap");
require("./ProposalPanel.scss");
var hm = function (hours) {
    var m = Math.round((hours || 0) * 60);
    return "".concat(Math.floor(m / 60), ":").concat("0".concat(m % 60).slice(-2));
};
var clock = function (d) { return moment(d).tz(constants_1.DEFAULT_TIMEZONE).format('HH:mm'); };
/**
 * GPS worklog proposal, preview only.
 *
 * All state lives in `answers`. Every interaction posts the full list and the
 * server replays it — there is no session to lose, which matters because the
 * API runs clustered. Nothing is ever written back to the worklogs.
 */
var ProposalPanel = /** @class */ (function (_super) {
    __extends(ProposalPanel, _super);
    function ProposalPanel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.searchTimer = null;
        _this.state = {
            loading: true, error: null, data: null, answers: [],
            selectedOptionId: null,
            manualOpen: false, manualQuery: '', manualResults: [], manualChosen: null, manualTime: '',
        };
        return _this;
    }
    ProposalPanel.prototype.componentDidMount = function () { this.send([]); };
    ProposalPanel.prototype.componentWillUnmount = function () { clearTimeout(this.searchTimer); };
    ProposalPanel.prototype.send = function (answers) {
        return __awaiter(this, void 0, void 0, function () {
            var data, firstOption, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setState({ loading: true, error: null });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, (0, server_1.post)(constants_1.API.GPS_PROPOSAL_URI, {
                                user: this.props.userId, date: this.props.date,
                                answers: answers,
                            })];
                    case 2:
                        data = _a.sent();
                        firstOption = data.question && data.question.options && data.question.options[0];
                        this.setState({
                            loading: false,
                            data: data,
                            answers: answers,
                            selectedOptionId: firstOption ? firstOption.id : null,
                            manualOpen: false, manualQuery: '', manualResults: [], manualChosen: null,
                            manualTime: data.question ? hm(data.question.minutes / 60) : '',
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        this.setState({ loading: false, error: (e_1 && e_1.message) || 'Er ging iets mis.' });
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ProposalPanel.prototype.answer = function (answer) {
        this.send(this.state.answers.concat([answer]));
    };
    ProposalPanel.prototype.undo = function () {
        this.send(this.state.answers.slice(0, -1));
    };
    ProposalPanel.prototype.searchLocations = function (term) {
        var _this = this;
        this.setState({ manualQuery: term });
        clearTimeout(this.searchTimer);
        if (term.trim().length < 2) {
            this.setState({ manualResults: [] });
            return;
        }
        this.searchTimer = setTimeout(function () { return __awaiter(_this, void 0, void 0, function () {
            var results, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, (0, server_1.get)("".concat(constants_1.API.GPS_PROPOSAL_URI, "/search"), { q: term, user: this.props.userId, date: this.props.date })];
                    case 1:
                        results = _a.sent();
                        this.setState({
                            manualResults: results || [],
                            manualChosen: results && results.length ? results[0].id : null,
                        });
                        return [3 /*break*/, 3];
                    case 2:
                        e_2 = _a.sent();
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); }, 250);
    };
    /** Accepts "1:30", "1.5" or "90m". */
    ProposalPanel.prototype.parseTime = function (v) {
        var s = String(v || '').trim();
        var m = s.match(/^(\d+):([0-5]?\d)$/);
        if (m) {
            return Number(m[1]) + Number(m[2]) / 60;
        }
        m = s.match(/^(\d+(?:[.,]\d+)?)\s*m(?:in)?$/i);
        if (m) {
            return parseFloat(m[1].replace(',', '.')) / 60;
        }
        m = s.match(/^(\d+(?:[.,]\d+)?)$/);
        if (m) {
            return parseFloat(m[1].replace(',', '.'));
        }
        return null;
    };
    ProposalPanel.prototype.submitManual = function () {
        var _a = this.state, manualChosen = _a.manualChosen, manualTime = _a.manualTime;
        if (!manualChosen) {
            return;
        }
        var onsiteH = this.parseTime(manualTime);
        if (onsiteH === null) {
            this.setState({ error: 'Tijd moet er uitzien als 1:30, 1.5 of 90m.' });
            return;
        }
        this.answer({ action: 'add-manual', locationId: manualChosen, onsiteH: onsiteH });
    };
    // ---------------------------------------------------------------- render
    ProposalPanel.prototype.renderQuestion = function () {
        var _this = this;
        var _a = this.state, data = _a.data, loading = _a.loading;
        if (!data || !data.question || data.done) {
            return this.renderDone();
        }
        var q = data.question;
        if (q.kind === 'boundary') {
            return (React.createElement("div", { className: "proposal-question" },
                React.createElement("div", { className: "when" },
                    clock(q.start),
                    "\u2013",
                    clock(q.end),
                    " \u00B7 ",
                    q.minutes,
                    " min \u00B7 geen werklocatie in de buurt"),
                React.createElement("div", { className: "ask" }, q.edge === 'start'
                    ? 'Stop vóór de eerste klus. Was hier al gewerkt?'
                    : 'Stop ná de laatste klus. Werd er nog gewerkt?'),
                React.createElement("p", { className: "hint" },
                    "Ja verschuift ",
                    q.edge === 'start' ? 'het begin' : 'het einde',
                    " van de werkdag en maakt",
                    ' ',
                    hm(q.absorbsHours),
                    " woon-werkverkeer tot werktijd."),
                React.createElement("div", { className: "proposal-actions" },
                    React.createElement("button", { className: "primary", disabled: loading, onClick: function () { return _this.answer({ action: 'add' }); } }, "Ja, er werd gewerkt"),
                    React.createElement("button", { disabled: loading, onClick: function () { return _this.answer({ action: 'skip' }); } }, "Nee, onderweg"),
                    React.createElement("button", { disabled: loading, onClick: function () { return _this.answer({ action: 'stop' }); } }, "Werkdag afsluiten"))));
        }
        return (React.createElement("div", { className: "proposal-question" },
            React.createElement("div", { className: "when" },
                clock(q.start),
                "\u2013",
                clock(q.end),
                " \u00B7 ",
                q.minutes,
                " min op locatie"),
            React.createElement("div", { className: "ask" }, "Welke werklocatie was dit?"),
            React.createElement("div", { className: "proposal-options" }, q.options.map(function (o) { return (React.createElement("label", { key: o.id, className: "proposal-option" },
                React.createElement("input", { type: "radio", name: "proposal-option", checked: _this.state.selectedOptionId === o.id, onChange: function () { return _this.setState({ selectedOptionId: o.id }); } }),
                React.createElement("span", { className: "num" }, o.number),
                React.createElement("span", { className: "nm" },
                    o.name,
                    o.city ? " \u00B7 ".concat(o.city) : ''),
                React.createElement("span", { className: "d" },
                    o.distM,
                    "m \u00B7 ",
                    o.type))); })),
            React.createElement("p", { className: "hint" },
                "Toevoegen boekt ",
                React.createElement("b", null, hm(q.absorbsHours)),
                " \u2014 de tijd op locatie plus alles sinds de vorige locatie (rijden, groothandel, pauze)."),
            React.createElement("div", { className: "proposal-actions" },
                React.createElement("button", { className: "primary", disabled: loading || !this.state.selectedOptionId, onClick: function () { return _this.answer({ action: 'add', locationId: _this.state.selectedOptionId }); } }, "Werklocatie toevoegen"),
                React.createElement("button", { disabled: loading, onClick: function () { return _this.setState({ manualOpen: !_this.state.manualOpen }); } }, "Geen van deze\u2026"),
                React.createElement("button", { disabled: loading, onClick: function () { return _this.answer({ action: 'skip' }); } }, "Geen werklocatie"),
                React.createElement("button", { disabled: loading, onClick: function () { return _this.answer({ action: 'stop' }); } }, "Werkdag afsluiten")),
            this.state.manualOpen && this.renderManual(q.minutes)));
    };
    ProposalPanel.prototype.renderManual = function (detectedMinutes) {
        var _this = this;
        return (React.createElement("div", { className: "proposal-manual" },
            React.createElement("div", { className: "ask small" }, "Zelf een locatie invoeren"),
            React.createElement("input", { type: "text", placeholder: "Zoek op nummer, naam of straat\u2026", value: this.state.manualQuery, onChange: function (e) { return _this.searchLocations(e.target.value); } }),
            React.createElement("div", { className: "proposal-options" }, this.state.manualResults.length === 0
                ? React.createElement("p", { className: "hint" }, "Typ minimaal twee tekens.")
                : this.state.manualResults.map(function (r) { return (React.createElement("label", { key: r.id, className: "proposal-option" },
                    React.createElement("input", { type: "radio", name: "proposal-manual-option", checked: _this.state.manualChosen === r.id, onChange: function () { return _this.setState({ manualChosen: r.id }); } }),
                    React.createElement("span", { className: "num" }, r.number),
                    React.createElement("span", { className: "nm" },
                        r.name,
                        r.city ? " \u00B7 ".concat(r.city) : ''),
                    React.createElement("span", { className: "d" },
                        r.type,
                        r.stale ? ' · gesloten' : ''))); })),
            React.createElement("div", { className: "proposal-time" },
                React.createElement("label", null, "Tijd op locatie"),
                React.createElement("input", { type: "text", value: this.state.manualTime, onChange: function (e) { return _this.setState({ manualTime: e.target.value }); } }),
                React.createElement("span", { className: "hint" },
                    "uren:minuten \u2014 gemeten ",
                    hm(detectedMinutes / 60))),
            React.createElement("div", { className: "proposal-actions" },
                React.createElement("button", { className: "primary", disabled: this.state.loading || !this.state.manualChosen, onClick: function () { return _this.submitManual(); } }, "Deze locatie toevoegen"),
                React.createElement("button", { onClick: function () { return _this.setState({ manualOpen: false }); } }, "Annuleren"))));
    };
    ProposalPanel.prototype.renderDone = function () {
        return (React.createElement("div", { className: "proposal-question done" },
            React.createElement("div", { className: "ask" }, "Dag compleet"),
            React.createElement("p", { className: "hint" },
                "Alle stops zijn verwerkt. ",
                (this.state.data && this.state.data.result
                    && this.state.data.result.lines.length) || 0,
                " werklocatie(s) geboekt.")));
    };
    ProposalPanel.prototype.renderTimesheet = function () {
        var data = this.state.data;
        var result = data && data.result;
        if (!result || !result.lines.length) {
            return React.createElement("p", { className: "hint" }, "Nog geen werklocatie toegevoegd.");
        }
        var worker = data && data.worker;
        return (React.createElement("table", { className: "proposal-timesheet" },
            React.createElement("thead", null,
                React.createElement("tr", null,
                    React.createElement("th", null, "Nummer"),
                    React.createElement("th", null, "Locatie"),
                    React.createElement("th", null, "Regel"),
                    React.createElement("th", { className: "n" }, "Uren"))),
            React.createElement("tbody", null,
                result.lines.map(function (l) { return [
                    React.createElement("tr", { key: "".concat(l.locationId, "-w"), className: "loc" },
                        React.createElement("td", { className: "mono", rowSpan: 2 }, l.number),
                        React.createElement("td", { className: "lname", rowSpan: 2 },
                            l.name,
                            l.city ? React.createElement(React.Fragment, null,
                                React.createElement("br", null),
                                React.createElement("span", { className: "muted" }, l.city)) : null,
                            l.manual ? React.createElement(React.Fragment, null,
                                React.createElement("br", null),
                                React.createElement("span", { className: "muted" }, "handmatig ingevoerd")) : null),
                        React.createElement("td", null,
                            "Werkuren ",
                            React.createElement("span", { className: "muted" }, "\u2014 op locatie")),
                        React.createElement("td", { className: "n" }, hm(l.bookedOnsiteH))),
                    React.createElement("tr", { key: "".concat(l.locationId, "-r"), className: "loc2" },
                        React.createElement("td", null,
                            "Reisuren ",
                            React.createElement("span", { className: "muted" }, "\u2014 reizen naar deze locatie")),
                        React.createElement("td", { className: "n" }, hm(l.bookedTravelH))),
                ]; }),
                React.createElement("tr", { className: "loc" },
                    React.createElement("td", { className: "mono", rowSpan: 2 }, "\u2014"),
                    React.createElement("td", { className: "lname", rowSpan: 2 }, "Woon-werkverkeer"),
                    React.createElement("td", null,
                        "Reisuren ",
                        React.createElement("span", { className: "muted" }, "\u2014 naar de eerste locatie")),
                    React.createElement("td", { className: "n" }, hm((result.commute && result.commute.toFirstH) || 0))),
                React.createElement("tr", { className: "loc2" },
                    React.createElement("td", null,
                        "Reisuren ",
                        React.createElement("span", { className: "muted" }, "\u2014 vanaf de laatste locatie")),
                    React.createElement("td", { className: "n" }, hm((result.commute && result.commute.fromLastH) || 0))),
                React.createElement("tr", { className: "total" },
                    React.createElement("td", { colSpan: 3 },
                        "Totaal (norm ",
                        result.dailyNorm,
                        "u)"),
                    React.createElement("td", { className: "n" }, hm(result.totals.countedH)))),
            React.createElement("tfoot", null,
                React.createElement("tr", null,
                    React.createElement("td", { colSpan: 4 },
                        React.createElement("p", { className: "hint" },
                            React.createElement("b", null, "Reizen naar deze locatie"),
                            " is alles tussen het verlaten van de vorige locatie en het verlaten van deze \u2014 rijden, groothandel, elke stop die we niet konden benoemen.",
                            React.createElement("br", null),
                            "Afgerond op 10 minuten, nooit meer dan 7 minuten erbij.",
                            React.createElement("br", null),
                            "Woon-werkverkeer wordt weergegeven zoals gemeten; eigen reistijd (",
                            worker ? worker.travelTime : 0,
                            "u) en pauze (",
                            worker ? worker.lunchTime : 0,
                            "u) worden hier niet afgetrokken."))))));
    };
    ProposalPanel.prototype.renderApproved = function () {
        var approved = this.state.data && this.state.data.approved;
        if (!approved || !approved.lines.length) {
            return React.createElement("p", { className: "hint" }, "Geen geboekte uren voor deze dag.");
        }
        return (React.createElement("table", { className: "proposal-timesheet" },
            React.createElement("thead", null,
                React.createElement("tr", null,
                    React.createElement("th", null, "Nummer"),
                    React.createElement("th", null, "Locatie"),
                    React.createElement("th", null, "Regel"),
                    React.createElement("th", { className: "n" }, "Uren"))),
            React.createElement("tbody", null,
                approved.lines.map(function (l, i) { return (React.createElement("tr", { key: i },
                    React.createElement("td", { className: "mono" }, l.number || '\u2014'),
                    React.createElement("td", { className: "lname" }, l.name || ''),
                    React.createElement("td", null,
                        l.type,
                        l.isSpecial ? React.createElement("span", { className: "muted" }, " \u2014 niet gewerkt") : null),
                    React.createElement("td", { className: "n" }, hm(l.hours)))); }),
                React.createElement("tr", { className: "total" },
                    React.createElement("td", { colSpan: 3 }, "Totaal"),
                    React.createElement("td", { className: "n" }, hm(approved.hours))))));
    };
    /** Names the stop the map is highlighting, so the pin and the question below
     *  are obviously the same thing. */
    ProposalPanel.prototype.renderMapCaption = function () {
        var data = this.state.data;
        var q = data && data.question;
        if (!q) {
            return React.createElement("div", { className: "proposal-map-caption done" }, "Hele dag \u2014 alle stops verwerkt");
        }
        return (React.createElement("div", { className: "proposal-map-caption" },
            React.createElement("span", { className: "dot current" }),
            "Nu in beeld: ",
            React.createElement("b", null,
                clock(q.start),
                "\u2013",
                clock(q.end)),
            " \u00B7 ",
            q.minutes,
            " min",
            q.kind === 'boundary'
                ? ' · stop zonder werklocatie in de buurt'
                : " \u00B7 ".concat(q.options.length, " mogelijke locatie").concat(q.options.length === 1 ? '' : 's')));
    };
    ProposalPanel.prototype.renderMapLegend = function () {
        return (React.createElement("div", { className: "proposal-map-legend" },
            React.createElement("span", null,
                React.createElement("i", { className: "dot current" }),
                "Huidige vraag"),
            React.createElement("span", null,
                React.createElement("i", { className: "dot booked" }),
                "Geboekt (genummerd)"),
            React.createElement("span", null,
                React.createElement("i", { className: "dot pending" }),
                "Keuze nodig"),
            React.createElement("span", null,
                React.createElement("i", { className: "dot unknown" }),
                "Geen werklocatie"),
            React.createElement("span", null,
                React.createElement("i", { className: "line done" }),
                "Al verwerkt"),
            React.createElement("span", null,
                React.createElement("i", { className: "line todo" }),
                "Nog te gaan")));
    };
    ProposalPanel.prototype.renderComparison = function () {
        var data = this.state.data;
        var result = data && data.result;
        if (!result) {
            return null;
        }
        var approvedDay = (data && data.approved) || { hours: 0, locationIds: [], lines: [] };
        var proposed = result.totals.countedH;
        var approved = approvedDay.hours;
        var delta = proposed - approved;
        var matched = result.lines
            .filter(function (l) { return approvedDay.locationIds.indexOf(l.locationId) !== -1; }).length;
        return (React.createElement("div", { className: "proposal-comparison" },
            React.createElement("div", null,
                React.createElement("span", null, "Voorstel"),
                React.createElement("b", null, hm(proposed))),
            React.createElement("div", null,
                React.createElement("span", null, "Goedgekeurd"),
                React.createElement("b", null, hm(approved))),
            React.createElement("div", { className: "delta ".concat(Math.abs(delta) <= 0.5 ? 'ok' : delta > 0 ? 'over' : 'under') },
                React.createElement("span", null, "Verschil"),
                React.createElement("b", null,
                    delta >= 0 ? '+' : '−',
                    hm(Math.abs(delta)))),
            React.createElement("div", { className: "locs" },
                React.createElement("span", null, "Locaties"),
                React.createElement("b", null,
                    matched,
                    "/",
                    approvedDay.locationIds.length))));
    };
    ProposalPanel.prototype.render = function () {
        var _this = this;
        var _a = this.state, data = _a.data, loading = _a.loading, error = _a.error;
        return (React.createElement("div", { className: "proposal-panel" },
            React.createElement("div", { className: "proposal-header" },
                React.createElement("span", { className: "component-title" },
                    "GPS-voorstel (alleen ter inzage)",
                    data && data.worker ? " \u2014 ".concat(data.worker.name, ", ").concat(this.props.date) : ''),
                React.createElement("div", { className: "spacer" }),
                this.state.answers.length > 0 &&
                    React.createElement("button", { disabled: loading, onClick: function () { return _this.undo(); } }, "Stap terug")),
            error && React.createElement("p", { className: "proposal-error" }, error),
            !data && loading && React.createElement("div", { className: "loading-container" },
                React.createElement("div", { className: "loading" })),
            data && !data.usable &&
                React.createElement("p", { className: "hint" },
                    data.reason,
                    " Er kan geen voorstel worden gemaakt voor deze dag."),
            data && data.usable && React.createElement(React.Fragment, null,
                React.createElement("div", { className: "proposal-meta" },
                    data.coverage ? "".concat(data.coverage.fixes, " GPS-punten") : '',
                    data.buildMs != null ? " \u00B7 opgebouwd in ".concat(data.buildMs, "ms").concat(data.cached ? ' (cache)' : '') : '',
                    data.replayUs != null ? " \u00B7 stap ".concat(data.replayUs, "\u00B5s") : ''),
                this.renderMapCaption(),
                React.createElement(ProposalMap_1.default, { map: data.map }),
                this.renderMapLegend(),
                this.renderComparison(),
                this.renderQuestion(),
                React.createElement("div", { className: "proposal-section-title" }, "Voorgestelde urenstaat"),
                this.renderTimesheet(),
                React.createElement("div", { className: "proposal-section-title" }, "Goedgekeurde urenstaat"),
                this.renderApproved())));
    };
    return ProposalPanel;
}(React.Component));
exports.default = ProposalPanel;
